import {
  ACTION_TYPE,
  FETCH_ACTIVE_TAB,
  FETCH_ASSIGN_VENDOR_DATA,
  FETCH_TRANSACTION_TYPE,
  FETCH_VENDOR_DATA,
  FETCH_WEBSITE_DATA,
} from "../../constants/ActionTypes";

export const fetchTransactionType = (data) => {
  return {
    type: FETCH_TRANSACTION_TYPE,
    payload: data,
  };
};

export const fetchActiveTab = (data) => {
  return {
    type: FETCH_ACTIVE_TAB,
    payload: data,
  };
};

export const fetchAllWebsiteList = (data) => {
  return {
    type: FETCH_WEBSITE_DATA,
    payload: data,
  };
};

export const fetchVendorData = (data) => {
  return {
    type: FETCH_VENDOR_DATA,
    payload: data,
  };
};

export const fetchAssignVendorList = (data) => {
  return {
    type: FETCH_ASSIGN_VENDOR_DATA,
    payload: data,
  };
};

export const actionType = (data) => {
  return {
    type: ACTION_TYPE,
    payload: data,
  };
};
